import React from 'react';

const Divider = () => {
    const dividerStyle = {
        height: '1px',
        backgroundColor: '#ccc',
        margin: '5px 0'
    };

    return <div style={dividerStyle}></div>;
};

export default Divider;